// "Resumen" of the open-match create flow (T17). Same card as the reservation checkout (`.sum-card`, rows
// `.rs-row`) but with the open-match facts: court, date, time, duration, players "N de M", price per player
// and "Pagás tu parte en el club" (nothing is paid online, there is no deposit and no hold countdown).
// `variant="mobile"` renders the same rows as a compact two-column block for the data step.
import React from "react";
import RIcon from "../../reservas/components/ReservasIcons";
import { FALLBACK_IMAGE } from "../../reservas/components/ReservaShared";
import { perPlayerPrice } from "../../../constants/courtDomain";
import { formatPricePerPlayer } from "../openMatchesModel";

const OpenMatchSummary = ({
	variant = "desktop",
	clubName,
	image,
	courtName,
	date,
	slotStart,
	slotEnd,
	duration,
	alreadyPlayers,
	capacity,
	price,
}) => {
	const share = perPlayerPrice(price, capacity);
	const rows = [
		courtName && { key: "court", icon: "ticket", k: "Cancha", v: courtName },
		date && { key: "date", icon: "cal", k: "Fecha", v: date.format("DD/MM/YYYY") },
		slotStart && { key: "time", icon: "clock", k: "Horario", v: `${slotStart} hs` },
		duration && { key: "dur", icon: "clock", k: "Duración", v: `${duration} min` },
		capacity > 0 && { key: "players", icon: "users", k: "Jugadores", v: `${alreadyPlayers} de ${capacity}` },
		share !== null && { key: "share", icon: "ticket", k: "Precio por jugador", v: formatPricePerPlayer(share) },
	].filter(Boolean);

	const renderRows = () =>
		rows.map((r) => (
			<div className="rs-row" key={r.key}>
				<span className="k"><RIcon name={r.icon} />{r.k}</span>
				<span className="v">{r.v}</span>
			</div>
		));
	const note = (
		<div className="rs-note" style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 6 }}>
			<RIcon name="shield" width={15} height={15} />
			Pagás tu parte en el club
		</div>
	);

	if (variant === "mobile") {
		return (
			<div className="oma-mob-summary" data-testid="open-match-summary">
				<h4>Resumen</h4>
				<div className="oma-mob-rows">{renderRows()}</div>
				{note}
			</div>
		);
	}

	return (
		<div className="sum-card" data-testid="open-match-summary">
			<div className="sum-img">
				<img src={image || FALLBACK_IMAGE} alt={clubName} onError={(e) => { e.currentTarget.src = FALLBACK_IMAGE; }} />
				<div className="sc" />
				<div className="bn">{clubName}</div>
			</div>
			<div className="sum-body">
				<h4>Resumen</h4>
				{renderRows()}
				<div className="rs-div" />
				{note}
			</div>
		</div>
	);
};

export default OpenMatchSummary;
